// Maintenance Mode Configuration
// Set to true to enable maintenance mode, false to disable
export const MAINTENANCE_CONFIG = {
  enabled: false,
    
  // Optional: Customize maintenance page content
  title: 'Under Maintenance',
  message: "We're currently performing scheduled maintenance to improve your experience. We'll be back online shortly!",
  contactEmail: 'support@linksy.community',

  // Optional: Schedule maintenance (for future use)
  scheduledStart: null, // e.g., '2024-12-20T10:00:00Z'
  scheduledEnd: null,   // e.g., '2024-12-20T14:00:00Z'
};